module.exports = __webpack_public_path__ + "img/person-simple.b12e6c68.svg";